import { BRAZIL_PILOT_CATEGORY_CODES } from './tariffs.js';
/** The physical vehicle class of a bicycle (`@vello/service-categories` VEHICLE_CLASSES vocabulary). */
const BICYCLE_CLASS = 'bike';
/** The heavy classes that do parcels only (owner 2026-11-01, D871 Q7), in the same vocabulary. */
const HEAVY_PARCEL_CLASSES = ['van', 'utility', 'truck'];
/** The motorcycle category code of the pilot tariffs; every other pilot category is a car category. */
const MOTO = 'moto';
export const BRAZIL_KYC_TYPE_CODES = {
    licence: 'CNH_EAR',
    address: 'PROOF_OF_ADDRESS',
    passengerInsurance: 'APP_PASSENGER_INSURANCE',
    vehicleRegistration: 'CRLV',
    vehicleInsurance: 'VEHICLE_INSURANCE',
    backgroundCheck: 'CRIMINAL_RECORD_CERTIFICATE',
};
const T = BRAZIL_KYC_TYPE_CODES;
const TYPES = [
    {
        code: T.licence, subject: 'PERSON', rules: { number: true, expiry: true, frontBack: true, photo: true }, expiryNoticeDays: 30, active: true,
        labels: { pt: 'CNH com EAR (exerce atividade remunerada)', en: 'Driver licence with paid-activity endorsement (EAR)' },
    },
    {
        code: T.address, subject: 'PERSON', rules: { number: false, expiry: true, frontBack: false, photo: false }, expiryNoticeDays: 15, active: true,
        // Owner answer (2026-09-25, PR 291 question 4): a proof of address carries no expiry — valid 90 days from its issue date.
        validityFromIssue: { amount: 90, unit: 'day' },
        labels: { pt: 'Comprovante de endereço', en: 'Proof of address' },
    },
    {
        code: T.passengerInsurance, subject: 'VEHICLE', rules: { number: true, expiry: true, frontBack: false, photo: false }, expiryNoticeDays: 30, active: true,
        labels: { pt: 'Seguro APP de passageiros', en: 'Passenger personal-accident insurance (APP)' },
    },
    {
        code: T.vehicleRegistration, subject: 'VEHICLE', rules: { number: true, expiry: true, frontBack: false, photo: false }, expiryNoticeDays: 30, active: true,
        labels: { pt: 'CRLV (documento do veículo)', en: 'Vehicle registration and licensing (CRLV)' },
    },
    {
        code: T.vehicleInsurance, subject: 'VEHICLE', rules: { number: true, expiry: true, frontBack: false, photo: false }, expiryNoticeDays: 30, active: true,
        labels: { pt: 'Seguro do carro', en: 'Car insurance' },
    },
    {
        code: T.backgroundCheck, subject: 'PERSON', rules: { number: false, expiry: true, frontBack: false, photo: false }, expiryNoticeDays: 15, active: true,
        // Owner answer (2026-09-25, PR 291 question 4): with no expiry printed, valid 6 months from its issue date.
        validityFromIssue: { amount: 6, unit: 'month' },
        labels: { pt: 'Atestado de antecedentes criminais', en: 'Criminal record certificate' },
    },
];
const country = (documentType, persona, requirement = 'REQUIRED', category) => ({
    documentType, persona, scope: 'country', requirement, ...(category !== undefined ? { category } : {}),
});
/** Brazil's catalog (pure data). */
export function brazilKycCatalog() {
    const carCategories = BRAZIL_PILOT_CATEGORY_CODES.filter((c) => c !== MOTO);
    return {
        country: 'BR',
        types: TYPES,
        requirements: [
            country(T.licence, 'driver'),
            country(T.address, 'driver'),
            country(T.passengerInsurance, 'driver'),
            country(T.vehicleRegistration, 'driver'),
            country(T.backgroundCheck, 'driver'),
            ...carCategories.map((c) => country(T.vehicleInsurance, 'driver', 'REQUIRED', c)),
            country(T.vehicleInsurance, 'driver', 'OPTIONAL', MOTO),
            country(T.licence, 'courier'),
            country(T.address, 'courier'),
            country(T.backgroundCheck, 'courier'),
            country(T.vehicleRegistration, 'courier'),
        ],
        vehicleRules: BRAZIL_PILOT_CATEGORY_CODES.map((category) => ({
            category,
            rule: { allowedVehicleTypes: [category === MOTO ? 'moto' : 'car'], requireValidInspection: true, requireActiveVehicle: true },
        })),
        // Owner answer (2026-09-25, PR 291 question 5): a courier riding a bicycle (non-motorized) needs neither the operator
        // inspection nor the vehicle documents (CRLV, insurances). Every motorized class keeps both (no rule = both required);
        // the ride persona is unaffected.
        // Owner decision (2026-11-01, D871 Q7, D886): van, utility and truck need no operator inspection either, but keep their vehicle documents.
        vehicleClassRules: [
            { vehicleClass: BICYCLE_CLASS, requiresInspection: false, requiresVehicleDocuments: false },
            ...HEAVY_PARCEL_CLASSES.map((vehicleClass) => ({ vehicleClass, requiresInspection: false, requiresVehicleDocuments: true })),
        ],
    };
}
/** When Brazil's catalog v1 takes effect (pack data, UTC) — before the pilot seed's own instants, like the other pack dates. */
export const BRAZIL_KYC_CATALOG_EFFECTIVE_FROM = '2026-09-01T00:00:00Z';
/** The reason the pack seed records on the catalog version it proposes and approves. */
export const BRAZIL_KYC_CATALOG_SEED_REASON = 'country-pack seed: Brazil KYC catalog (owner answer D435 §5.0 items 5–6; D886: van, utility and truck exempt from the inspection, D871 Q7)';
//# sourceMappingURL=kyc-catalog.js.map